import React, { useEffect, useState } from "react";
import WidgetPageWrapper from "./WidgetPageWrapper";
import ActiveUsers from "./ActiveUsers";
import useAnalytics from "./AnalyticsHook";
import { Spinner } from "react-bootstrap";

const ActiveUsersPage = () => {
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const { FetchAnalyticsData } = useAnalytics();

  const [analyticsActiveUsers, setAnalyticsActiveUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (cancelled) return;
      try {
        setAnalyticsLoading(true);

        var responseData = await FetchAnalyticsData();

        if (cancelled) return;

        // setAnalyticsCurrentMonthCode(responseData.currentMonthCode);
        // setAnalyticsSessionHistories(responseData.sessionHistories);
        setAnalyticsActiveUsers(responseData.activeUsers);
      } catch (error) {
        console.log(error);
      } finally {
        setAnalyticsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <WidgetPageWrapper title={"Active Users"} loading={loading}>
        {analyticsLoading ? (
          <Spinner />
        ) : (
          <ActiveUsers
            activeUsers={analyticsActiveUsers}
            mode="page"
            setLoading={setLoading}
          />
        )}
      </WidgetPageWrapper>
    </>
  );
};

export default ActiveUsersPage;
